import {
  OtherDeduction,
  ReferredCommission,
  TeamLeaderDeduction,
  TeamLeaderCommission,
  CobrokerTeamLeader,
  CobrokerCommission
} from './RenditionModelBE.model';
import {
  InvoiceRenditionAgentBilling,
  InvoiceRenditionAgentPayment,
  InvoiceRenditionBilling
} from './invoices.model';

export class RenditionModel {
  'renditionId': number | null;
  'id': number | null;
  'mlsId': string | null;
  'amountByRental': boolean;
  'contractTimeType': number | null;
  'contractTime': number | null;
  'reservationId': number | null;
  'reservationNotes': string | null;
  'propertyType': number | null;
  'exclusivityType': number;
  'renditionType': number;
  'operationType': number;
  'jurisdictionId': number | null;
  'agencyId': number;
  'propertyAddress': string;
  'sharedBy': number | null;
  'loggedUser': string;
  'exchangeRate': number;
  'relationFiftyFifty': boolean;
  'credit': boolean;
  'otherRealEstate': OtherRealEstate | null;
  'clientContact': ClientContact;
  'organizationCommission': OrganizationCommission;
  'renditionDate': string | null;
  'jurisdictionDeduction': Deduction;
  'salesJurisdictionDeduction': Deduction;
  'purchaseJurisdictionDeduction': Deduction;
  'saleDeduction': Deduction;
  'purchaseDeduction': Deduction;
  'otherDeductions': OtherDeduction[];
  'billings': InvoiceRenditionBilling[];
  'agentBillings': InvoiceRenditionAgentBilling[];
  'agentPayments': InvoiceRenditionAgentPayment[];
  'referredDeductions': ReferredRendition[];
  'referredCommissions': ReferredCommission[];
  'grossComissionPercentage': number;
  'grossComissionUSD': number | null;
  'grossComissionARS': number | null;
  'purchaseRelationshipPercentage': number;
  'saleRelationshipPercentage': number;
  'grossAgencyComissionPercentage': number | null;
  'grossAgencyComissionUSD': number | null;
  'grossAgencyComissionARS': number | null;
  'grossAgencyComissionPercentageWithoutReferredDeduction': number | null;
  'grossAgencyComissionUSDWithoutReferredDeduction': number | null;
  'grossAgencyComissionARSWithoutReferredDeduction': number | null;
  'saleOrganizationAmountCommissionUSD': number | null;
  'saleOrganizationAmountCommissionARS': number | null;
  'purchaseOrganizationAmountCommissionUSD': number | null;
  'purchaseOrganizationAmountCommissionARS': number | null;
  'agencyAmountCommissionUSD': number | null;
  'agencyAmountCommissionARS': number | null;
  'totalAmountOperationUSD': number | null;
  'quotaNumber'?: number | null;
  'totalAmountOperationARS': number | null;
  'notes': string | null;
  'renditionTypeTxt': string | null;
  'operationTypeTxt': string | null;
  'contractTimeTypeTxt': string | null;
  'propertyTypeTxt': string | null;
  'exclusivityTypeTxt': string | null;
  'sharedByTxt': string | null;
  'jurisdictionTxt': string | null;
  'sharedAgencyName': string | null;
  'sharedAgencyId': number | null;
  'purchaseOrganizationName': string | null;
  'saleOrganizationName': string | null;
  'agencyName': string | null;
  'billingSubTotalARS': number;
  'billingSubTotalIVAARS': number;
  'billingSubTotalIVAUSD': number;
  'billingSubTotalUSD': number;
  'billingTotalARS': number;
  'billingTotalUSD': number;
  'billingIVAAgentARS': number;
  'billingIVAAgentUSD': number;
  'bank': number | null;
  'bankText'?: string;
  'qrId': string;
  'entrepreneurshipId': string;
  'origin'?: number | null;
  'teamLeaderDeductions': TeamLeaderDeduction[];
  'teamLeaderCommissions': TeamLeaderCommission[];
  'cobrokersCommissions': CobrokerCommission[] | undefined;
  'cobrokerTeamLeaders': CobrokerTeamLeader[] | undefined;
  'royaltyAmount'?: number | null | undefined;
  'royaltyPercentage'?: number | null | undefined;
  'pendingCommissions'?: boolean | undefined;

  constructor() {
    this.renditionId = 0;
    this.id = 0;
    this.mlsId = null;
    this.amountByRental = false;
    this.contractTimeType = 0;
    this.contractTime = 0;
    this.reservationId = null;
    this.reservationNotes = null;
    this.propertyType = null;
    this.exclusivityType = 0;
    this.renditionType = 0;
    this.operationType = 0;
    this.jurisdictionId = null;
    this.agencyId = 0;
    this.propertyAddress = '';
    this.sharedBy = null;
    this.loggedUser = '';
    this.exchangeRate = 0;
    this.relationFiftyFifty = false;
    this.credit = false;
    this.otherRealEstate = null;
    this.clientContact = new ClientContact();
    this.organizationCommission = new OrganizationCommission();
    this.renditionDate = null;
    this.jurisdictionDeduction = new Deduction();
    this.salesJurisdictionDeduction = new Deduction();
    this.purchaseJurisdictionDeduction = new Deduction();
    this.saleDeduction = new Deduction();
    this.purchaseDeduction = new Deduction();
    this.otherDeductions = [];
    this.billings = [];
    this.agentBillings = [];
    this.agentPayments = [];
    this.referredDeductions = [];
    this.referredCommissions = [];
    this.grossComissionPercentage = 0;
    this.grossComissionUSD = null;
    this.grossComissionARS = null;
    this.purchaseRelationshipPercentage = 0;
    this.saleRelationshipPercentage = 0;
    this.grossAgencyComissionPercentage = 0;
    this.grossAgencyComissionUSD = 0;
    this.grossAgencyComissionARS = 0;
    this.grossAgencyComissionPercentageWithoutReferredDeduction = 0;
    this.grossAgencyComissionUSDWithoutReferredDeduction = 0;
    this.grossAgencyComissionARSWithoutReferredDeduction = 0;
    this.saleOrganizationAmountCommissionUSD = 0;
    this.saleOrganizationAmountCommissionARS = 0;
    this.purchaseOrganizationAmountCommissionUSD = 0;
    this.purchaseOrganizationAmountCommissionARS = 0;
    this.agencyAmountCommissionUSD = 0;
    this.agencyAmountCommissionARS = 0;
    this.totalAmountOperationUSD = 0;
    this.totalAmountOperationARS = 0;
    this.notes = null;
    this.renditionTypeTxt = null;
    this.operationTypeTxt = null;
    this.contractTimeTypeTxt = null;
    this.propertyTypeTxt = null;
    this.exclusivityTypeTxt = null;
    this.sharedByTxt = null;
    this.jurisdictionTxt = null;
    this.sharedAgencyName = '';
    this.purchaseOrganizationName = null;
    this.saleOrganizationName = null;
    this.agencyName = null;
    this.sharedAgencyId = 0;
    this.billingSubTotalARS = 0;
    this.billingSubTotalIVAARS = 0;
    this.billingSubTotalIVAUSD = 0;
    this.billingSubTotalUSD = 0;
    this.billingTotalARS = 0;
    this.billingTotalUSD = 0;
    this.billingIVAAgentARS = 0;
    this.billingIVAAgentUSD = 0;
    this.bank = null;
    this.qrId = '';
    this.entrepreneurshipId = '';
    this.origin = 2;
    this.teamLeaderDeductions = [];
    this.teamLeaderCommissions = [];
    this.cobrokersCommissions = [];
    this.cobrokerTeamLeaders = [];
  }
}

export class ReferredRendition {
  'agencyId': number | null;
  'typePayment'?: number | null;
  'organizationType': number | null;
  'organizationId': number | null;
  'organizationName': string | null;
  'deductionPercentage': number | null;
  'deductionAmountUSD': number | null;
  'deductionAmountARS': number | null;
  'referredDeductionAmountARS': number | null;
  'referredDeductionAmountUSD': number | null;
  'organizationIdOtherRemax': number | null;
  'organizationNameOtherRemax': string | null;

  constructor() {
    this.agencyId = null;
    this.typePayment = null;
    this.organizationType = null;
    this.organizationId = null;
    this.deductionPercentage = 0;
    this.deductionAmountUSD = 0;
    this.deductionAmountARS = 0;
    this.referredDeductionAmountUSD = 0;
    this.referredDeductionAmountARS = 0;
    this.organizationName = null;
    this.organizationIdOtherRemax = null;
    this.organizationNameOtherRemax = null;
  }
}

export class OtherRealEstate {
  'id': number;
  'name': string;
  'visible': boolean;

  constructor() {
    this.id = 0;
    this.name = '';
    this.visible = false;
  }
}

export class ClientContact {
  'purchaseOrganizationId': number | null;
  'saleOrganizationId': number | null;
  'purchaseCustomerOriginId': number | null;
  'saleCustomerOriginId': number | null;
  'purchaseOrganizationName': string | null;
  'purchaseClientName': string | null;
  'saleOrganizationName': string | null;

  constructor() {
    this.purchaseOrganizationId = null;
    this.saleOrganizationId = null;
    this.purchaseCustomerOriginId = null;
    this.saleCustomerOriginId = null;
    this.purchaseOrganizationName = null;
    this.purchaseClientName = null;
    this.saleOrganizationName = null;
  }
}

export class OrganizationCommission {
  'purchaseOrganizationId': number | null;
  'purchaseOrganizationType': number;
  'purchaseCommissionPercentage': number;
  'purchaseAmountUSD': number | null;
  'purchaseAmountARS': number | null;
  'purchaseOrganizationAgentType': string | null;
  'purchaseOrganizationIdOtherRemax': number | null;
  'purchaseOrganizationNameOtherRemax': string | null;
  'purchaseOrganizationTeamId': number | null;
  'purchaseOrganizationTeamLeaderId': number | null;
  'saleOrganizationId': number | null;
  'saleOrganizationType': number;
  'saleCommissionPercentage': number;
  'saleAmountUSD': number | null;
  'saleAmountARS': number | null;
  'purchaseOrganizationName': string | null;
  'saleOrganizationName': string | null;
  'saleOrganizationAgentType': string | null;
  'saleOrganizationIdOtherRemax': number | null;
  'saleOrganizationNameOtherRemax': string | null;
  'saleOrganizationTeamId': number | null;
  'saleOrganizationTeamLeaderId': number | null;

  constructor() {
    this.purchaseOrganizationId = 0;
    this.purchaseOrganizationType = 0;
    this.purchaseCommissionPercentage = 0;
    this.purchaseAmountUSD = null;
    this.purchaseAmountARS = null;
    this.saleOrganizationId = 0;
    this.saleOrganizationType = 0;
    this.saleCommissionPercentage = 0;
    this.saleAmountUSD = null;
    this.saleAmountARS = null;
    this.purchaseOrganizationName = null;
    this.saleOrganizationName = null;
    this.purchaseOrganizationAgentType = null;
    this.purchaseOrganizationIdOtherRemax = null;
    this.purchaseOrganizationNameOtherRemax = null;
    this.purchaseOrganizationTeamId = null;
    this.purchaseOrganizationTeamLeaderId = null;
    this.saleOrganizationAgentType = null;
    this.saleOrganizationIdOtherRemax = null;
    this.saleOrganizationNameOtherRemax = null;
    this.saleOrganizationTeamId = null;
    this.saleOrganizationTeamLeaderId = null;
  }
}

export class Deduction {
  'deductionPercentage': number;
  'deductionAmountUSD': number;
  'deductionAmountARS': number;

  constructor() {
    this.deductionPercentage = 0;
    this.deductionAmountUSD = 0;
    this.deductionAmountARS = 0;
  }
}
